import { AppGsvDomainConstant } from "../app-gsv-domain.constant";

export class TipoBalotaAPIConstant {
  static readonly QUERY_TIPOS_BALOTA: string = "type-ballot/find-type";
  static readonly CREATE_UPDATE_TIPO_BALOTA: string = "type-ballot";
  static readonly CHANGE_STATUS_TIPO_BALOTA: string = "type-ballot/status/";
  static readonly COPY_TIPO_BALOTA: string = "type-ballot/";
  static readonly ALL_QUERY_TIPO_BALOTA: string =
    "type-ballot/search-by-criteria/";

  static readonly QUERY_PARAMETER_FIELD_TYPES: string = "parameter/field-types";
  static readonly ALLQUERY_PARAMETER: string = "parameter/all/";

  static readonly CREATE_TYPE_BALLOT_PAREMETER: string = "type-ballot-parameter";
  static readonly CHANGE_TYPE_BALLOT_PAREMETER: string = "type-ballot-parameter/update";
  static readonly ALLQUERY_TYPE_BALLOT_PAREMETER: string = "type-ballot-parameter/all/";
  static readonly CHANGE_STATUS_TYPE_BALLOT_PAREMETER: string = "type-ballot-parameter/status/";
  static readonly QUERY_IMAGE_TYPE_BALLOT_PAREMETER: string = "type-ballot-parameter/";


  static readonly URL_QUERY_IMAGE_TYPE_BALLOT_PAREMETER: string =
  AppGsvDomainConstant.URI_GATEWAY_GSV +
  AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
  this.QUERY_IMAGE_TYPE_BALLOT_PAREMETER;

  static readonly URL_ALLQUERY_TYPE_BALLOT_PAREMETER: string =
  AppGsvDomainConstant.URI_GATEWAY_GSV +
  AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
  this.ALLQUERY_TYPE_BALLOT_PAREMETER;

  static readonly URL_CHANGE_STATUS_TYPE_BALLOT_PAREMETER: string =
  AppGsvDomainConstant.URI_GATEWAY_GSV +
  AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
  this.CHANGE_STATUS_TYPE_BALLOT_PAREMETER;

  static readonly URL_CREATE_TYPE_BALLOT_PAREMETER: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CREATE_TYPE_BALLOT_PAREMETER;

    static readonly URL_CHANGE_TYPE_BALLOT_PAREMETER: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_TYPE_BALLOT_PAREMETER;

  static readonly URL_ALLQUERY_PARAMETER: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.ALLQUERY_PARAMETER;

  static readonly URL_ALLQUERY_PARAMETER_FIELD_TYPES: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_PARAMETER_FIELD_TYPES;

  static readonly URL_ALLQUERY_TIPOS_BALOTAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_TIPOS_BALOTA;

  static readonly URL_CREATE_UPDATE_TIPO_BALOTA: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CREATE_UPDATE_TIPO_BALOTA;

  static readonly URL_CHANGE_STATUS_TIPO_BALOTA: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS_TIPO_BALOTA;

  static readonly URL_COPY_TIPO_BALOTA: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.COPY_TIPO_BALOTA;

  static readonly URL_ALLQUERY_TIPO_BALOTA: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.ALL_QUERY_TIPO_BALOTA;


  public static getAllEndpoints(): string[] {
      return [
          this.URL_CREATE_TYPE_BALLOT_PAREMETER,
          this.URL_CHANGE_TYPE_BALLOT_PAREMETER,
      ];
  }
}
